import { OperationalRecords } from '@/pages/ops/OperationalRecords';
import { ComplaintsPage } from './ComplaintsPage';
import { DoctorInboxPage } from './DoctorInboxPage';
/** Areas still served by this shared page (the rest have their own pages). */
export type ClinicalAreaMode = 'inbox' | 'complaints' | 'messages' | 'medicals';
type RegisterMode = Exclude<ClinicalAreaMode, 'inbox' | 'complaints'>;
const titles: Record<RegisterMode, string> = {
  messages: 'Messages',
  medicals: 'Medicals & documents',
};
const registerKinds: Record<RegisterMode, string[]> = {
  medicals: [
    'record_request',
    'employer_medical',
    'jpj_exam',
    'school_medical',
  ],
  messages: ['message_template', 'campaign'],
};
export function ClinicalAreasPage({ mode }: { mode: ClinicalAreaMode }) {
  if (mode === 'inbox') return <DoctorInboxPage />;
  if (mode === 'complaints') return <ComplaintsPage />;
  return (
    <OperationalRecords title={titles[mode]} kinds={registerKinds[mode]} />
  );
}
